import Doubt from "api/lib/abstract_query/interfaces/Doubt";
import DoubtType from "api/lib/abstract_query/interfaces/DoubtType";
import MetadataObject from "api/lib/data/interfaces/MetadataObject";
import * as _ from "lodash";
import * as React from "react";
import { Button, Segment } from "semantic-ui-react";
import { AceEditor, snippetsModule } from "./ace_messages";

export interface IMessageFormProps {
  metadata: MetadataObject;
  value: string;
  onChange: (str: string) => void;
  onClearQuery: () => void;
  doubts: Doubt[];
}
const editorProps = { $blockScrolling: Infinity };
const MessageForm = ({
  value,
  metadata,
  onChange,
  onClearQuery,
  doubts,
}: IMessageFormProps): React.ReactElement => {
  const ref = React.useRef(null);
  const [editorRef, setEditorRef] = React.useState(null);

  // For some reason, value for AceEditor should be managed in this way - otherwise it goes berserk when selecting text
  const [currentValue, setCurrentValue] = React.useState(value);

  React.useEffect(() => {
    if (isSortDoubt(doubts)) {
      editorRef.editor.setValue("sort by ", 1);
    } else {
      setCurrentValue(value);
    }
  }, [value, doubts]);

  const handleChange = React.useCallback(
    (str) => {
      setCurrentValue(str);
      //   onChange(str);
    },
    [value]
  );

  const isSortDoubt = (tdoubts: Doubt[]) => {
    const found = _.find(tdoubts, (doubt: Doubt) => {
      return doubt.type === DoubtType.NEED_SORTING_COLUMN;
    });
    if (found) {
      return true;
    }
    return false;
  };

  const handleSubmit = React.useCallback(
    (str) => {
      if (str) {
        onChange(str);
        setCurrentValue("");
      }
    },
    [value]
  );

  const editorOptions = React.useMemo(
    () => ({
      behavioursEnabled: true,
      enableSnippets: true,
      enableBasicAutocompletion: true,
      enableLiveAutocompletion: true,
      autoScrollEditorIntoView: true,
    }),
    []
  );
  // React.useEffect(() => {
  //   function resize() {
  //     if (editorRef) {
  //       editorRef.editor.resize();
  //     }
  //   }

  //   if (container) {
  //     resize();
  //     // const unwatch = resizeObserver(container, resize);
  //     return () => {// TODO };
  //   }
  // }, [container, editorRef]);

  const initEditor = React.useCallback((editor) => {
    editor.setAutoScrollEditorIntoView(true);
    editor.setOption("maxLines", 3);
    editor.setOption("indentedSoftWrap", false);
    const row = editor.session.getLength() - 1;
    const column = editor.session.getLine(row).length; // or simply Infinity
    editor.gotoLine(row + 1, column);

    // Release Cmd/Ctrl+L to the browser
    editor.commands.addCommand({
      name: "return",
      bindKey: { win: "Return", mac: "Return" },
      exec: (thisEditor) => {
        const curVal = thisEditor.getValue();
        if (curVal) {
          onChange(thisEditor.getValue());
          thisEditor.setValue("", 1);
        }
      },
    });

    editor.commands.addCommand({
      name: "shiftreturn",
      bindKey: { win: "Shift+Return", mac: "Shift+Return" },
      exec: (thisEditor) => {
        const currentEValue = thisEditor.getValue();
        thisEditor.setValue(currentEValue + "\n", 1);
      },
    });

    // Reset Completer in case dot is pressed
    editor.commands.on("afterExec", (e) => {
      if (
        e.command.name === "insertstring" &&
        e.args === "." &&
        editor.completer
      ) {
        editor.completer.showPopup(editor);
      }
    });

    const snippetManager = snippetsModule.snippetManager;
    const m = {
      snippetText: "",
      snippets: "",
      scope: "sql",
    };
    m.snippets = snippetManager.parseSnippetFile(m.snippetText);
    snippetManager.register([], m.scope);
    editor.focus();
  }, []);

  React.useImperativeHandle(
    ref,
    () => ({
      paste: (text) => {
        if (editorRef) {
          const { editor } = editorRef;
          editor.session.doc.replace(editor.selection.getRange(), text);
          const range = editor.selection.getRange();
          editor.selection.setRange(range);
        }
      },
      focus: () => {
        if (editorRef) {
          editorRef.editor.focus();
        }
      },
    }),
    [editorRef, onChange]
  );

  return (
    <React.Fragment>
      <Segment attached={true} style={{ border: "none" }}>
        <AceEditor
          ref={setEditorRef}
          placeholder="Message your team..."
          className="mousetrap"
          theme="textmate"
          mode={"text"}
          value={currentValue}
          editorProps={editorProps}
          minLines={1}
          width="100%"
          height="100%"
          setOptions={editorOptions}
          showPrintMargin={false}
          wrapEnabled={true}
          showGutter={false}
          highlightActiveLine={false}
          onLoad={initEditor}
          onChange={handleChange}
        />
      </Segment>
      <Segment attached={true}>
        <div
          style={{
            fontSize: "10px",
            height: "45px",
            width: "98%",
            position: "absolute",
            bottom: "0",
            left: "0",
          }}
        >
          <span
            style={{
              display: "inline-block",
              marginTop: "22px",
              padding: "0 20px",
            }}
          >
            Return to send
          </span>
          <span>Shift + Return to add a new line</span>

          <Button
            size="mini"
            icon="caret right"
            onClick={() => handleSubmit(currentValue)}
            disabled={currentValue === ""}
            style={{ position: "absolute", right: 0, bottom: 0 }}
          />
        </div>
      </Segment>
    </React.Fragment>
  );
};

export default MessageForm;



// WEBPACK FOOTER //
// ./src/components/Query/MessageForm.tsx